// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBM_Plex_Mono_2eef89', '__IBM_Plex_Mono_Fallback_2eef89'","fontStyle":"normal"},"className":"__className_2eef89","variable":"__variable_2eef89"};